import AmountMode from '@/App/tiles/ForwardAccumulator/parts/RightPanel/common/AmountMode.tsx';
import { ClientsWayInput } from '@/App/tiles/ForwardAccumulator/parts/RightPanel/common/ClientsWayInput.tsx';
import LeverageAmount from '@/App/tiles/ForwardAccumulator/parts/RightPanel/common/LeverageAmount.tsx';
import LeverageRatio from '@/App/tiles/ForwardAccumulator/parts/RightPanel/common/LeverageRatio.tsx';
import Notional from '@/App/tiles/ForwardAccumulator/parts/RightPanel/common/Notional.tsx';

export const InputGroup1 = () => (
  <>
    <ClientsWayInput />
    <Notional />
    <AmountMode />
    <LeverageRatio />
    <LeverageAmount isSchedule />
  </>
);
